// extracted by mini-css-extract-plugin
module.exports = {"abonnements":"Abonnements_abonnements__QZEY9","container":"Abonnements_container__1qOlO","mobile":"Abonnements_mobile__17acM","content":"Abonnements_content__2hBEh"};